import map from 'lodash/map'
import dynamic from 'next/dynamic'

const ImageMapper = dynamic(() => import('react-img-mapper'), {
  ssr: false,
})

export type ImageMapImage = {
  url: string
  width: number
  height: number
}

export type ImageMapArea = {
  imageIndex: number
  shape: 'circle' | 'rect' | 'poly'
  coords: number[]
  href?: string
  colorHex?: string
}

type ImageMapProps<T extends ImageMapArea> = {
  image: ImageMapImage
  areas: T[]
  width: number
  onClick: (area: T) => void
}

export function ImageMap<T extends ImageMapArea>(props: ImageMapProps<T>) {
  const { image, areas, width, onClick } = props
  const betterAreas: any = map(areas, (area) => {
    const { colorHex = '#508090' } = area
    return {
      active: true,
      disabled: undefined,

      preFillColor: `${colorHex}44`,
      fillColor: `${colorHex}bb`,
      strokeColor: `${colorHex}ff`,

      lineWidth: 2,
      ...area,
    }
  })

  const ratio = image.height / image.width
  const height = ratio * width

  return (
    <ImageMapper
      src={image.url}
      name="my-map"
      areas={betterAreas}
      imgWidth={image.width}
      width={width}
      height={height}
      onClick={(area: any) => onClick(area)}
    />
  )
}
